import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h2 futura bold color="#E6108C" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink href="https://www.facebook.com/pages/Sushi%20Aria/1012844792180773/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sushico Japanese Restaurant Facebook"
              />
            </CFLink> */}
            <CFLink href="https://www.yelp.ca/biz/sushico-chilliwack">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Sushico Japanese Restaurant Yelp"
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/masita-korean-cuisine-central-burnaby-burnaby">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Sushico Japanese Restaurant Zomato"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/chilliwacksushico/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushico Japanese Restaurant Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h2 futura bold color="#E6108C" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink href="https://www.facebook.com/pages/Sushi%20Aria/1012844792180773/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Sushico Japanese Restaurant Facebook"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.yelp.ca/biz/sushico-chilliwack">
              <CFImage
                w="45px"
                pr="10px"
                src={yelp}
                alt="Sushico Japanese Restaurant Yelp"
                hover
              />
            </CFLink>
            {/* <CFLink href="https://www.zomato.com/vancouver/masita-korean-cuisine-central-burnaby-burnaby">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Sushico Japanese Restaurant Zomato"
                hover
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/chilliwacksushico/">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Sushico Japanese Restaurant Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
